import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import downloadFromUrl from 'utils/downloadFromUrl';
import writeToFileURL from 'utils/upload/writeToFileURL';
var browserDownloader = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var signedUrl, data, fileName;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          signedUrl = params.signedUrl, data = params.data, fileName = params.fileName;
          if (!signedUrl) {
            _context.next = 4;
            break;
          }
          downloadFromUrl(signedUrl, {
            fileName: fileName
          });
          return _context.abrupt("return", Promise.resolve(true));
        case 4:
          if (!data) {
            _context.next = 7;
            break;
          }
          downloadFromUrl(writeToFileURL(data), {
            fileName: fileName
          });
          return _context.abrupt("return", Promise.resolve(true));
        case 7:
          return _context.abrupt("return", Promise.resolve(null));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function browserDownloader(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default browserDownloader;